import React from 'react';
import IHasItemDataProps from './IHasItemDataProps';
import IHasItemEventProps from './IHasItemEventProps';
import IItemProps from './IItemProps';
import SharedItemCells from './SharedItemCells';
import { IAggregateAdjustmentViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

interface IAggregateAdjustment
  extends IItemProps,
    IHasItemDataProps<IAggregateAdjustmentViewItem>,
    IHasItemEventProps<IAggregateAdjustmentViewItem> {}

export default class AggregateAdjustment extends React.Component<IAggregateAdjustment> {
  public render() {
    return (
      <SharedItemCells {...this.props} allowNegative={true} readOnly={!this.props.hasEditPermissions}>
        Aggregate Adjustment
      </SharedItemCells>
    );
  }
}
